import React, { Component } from 'react';

export default class ShadowsAbout extends Component {
  render () {
    return (
      <div>
        <div className="shadows-main-text">
          <div className="shadows-header">
            <div className="shadows-header-text">
              About the project
            </div>
            <div className="shadows-about-text">
              <p>
                Hello there!
              </p>
              <p>
                We're glad you're here. Thanks for visiting Trendy CSS Long Text Shadows. This is a free project made by the team at Mixfont, the online font generator. 
              </p>
              <p>
                Brought to you by <a href="/">Mixfont</a>, the modern font generator.
              </p>
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/projects/shadows/ShadowsAbout.jsx